/**
 * Class changes url params or delete
 * **/

class SearchParams {
    set(name, value) {
        try {
            if ('URLSearchParams' in window && name !== undefined && value !== undefined) {
                const searchParams = this._getSearchParams();
                searchParams.set(name, value);
                this._setSearchParams(searchParams);
                return;
            }
            console.warn(`name or value are empty`, name, value);
        } catch (err) {
            console.error(err);
        }
    }
    delete(name) {
        try {
            if ('URLSearchParams' in window && name !== undefined) {
                const searchParams = this._getSearchParams();
                searchParams.delete(name);
                this._setSearchParams(searchParams);
                return;
            }
            console.warn(`name or value are empty`, name);
        } catch (err) {
            console.error(err);
        }
    }
    _getSearchParams() {
        const paramsString = location.search;
        return new URLSearchParams(paramsString);
    }
    _setSearchParams(searchParams) {
        const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + location.hash;
        history.pushState(null, '', newRelativePathQuery);
    }
}

export default new SearchParams();